import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-devices'

export const getAllDevices = async (token, page, itemPerPage = getItemPerPage()) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-all`, {
        page: page,
        itemPerPage: itemPerPage
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const update = async (token, id, name, code, status) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        id: id,
        name: name,
        code: code,
        status: status
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const add = async (token, code, name, status) => {
    try {
        const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, {
            code: code,
            name: name,
            status: status
        }, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
        return false
    } catch (error) {
        return error.response?.data || false
    }
}

export const deleteDevice = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/delete`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const assignEmployee = async (token, deviceId, employeeId) => {
    try {
        const response = await axios.post(`${host}/${PLUGINS_NAME}/assign-employee`, {
            deviceId: deviceId,
            employeeId: employeeId
        }, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
        return false
    } catch (error) {
        console.error('Error assigning employee:', error)
        return false
    }
}

export const getEmployeesForAssign = async (token, search = '') => {
    try {
        const response = await axios.get(`${host}/${PLUGINS_NAME}/employees`, {
            params: {
                search: search
            },
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
        return false
    } catch (error) {
        console.error('Error getting employees:', error)
        return false
    }
}